module.exports = __webpack_public_path__ + "img/tiktok.2d9812c2.svg";